<template>
  <div class="all-height d-flex justify-center" data-testid="queries-view">
    <div class="all-width" data-testid="queries-view__container">
      <v-card class="shadow-off" loader-height="2" :loading="loading" :disabled="loading" data-testid="queries-view__card">
        <v-card-text data-testid="queries-view__card-text">
          <div class="d-flex flex-column mb-2" data-testid="queries-view__header">
            <div data-testid="queries-view__header-row">
              <div class="d-flex align-center" data-testid="queries-view__header-actions">
                <v-tooltip bottom content-class="tooltip-bottom" data-testid="queries-view__back-tooltip">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn v-bind="attrs" v-on="on" class="shadow-off" icon
                      @click="$router.go(-1)" data-testid="queries-view__back-btn"><v-icon data-testid="queries-view__back-icon">mdi-arrow-left</v-icon></v-btn>
                  </template>
                  <span data-testid="queries-view__back-label">Back to Ticket list</span>
                </v-tooltip>
                <v-btn icon @click="refreshData()" data-testid="queries-view__refresh-btn">
                  <v-icon data-testid="queries-view__refresh-icon">mdi-refresh</v-icon></v-btn>
                <div class="ml-4" v-if="queryDetails._id" data-testid="queries-view__status-container">
                  <v-chip v-if="queryDetails.stage === 0" label class="Tabblue--text" color="lightblue" data-testid="queries-view__status-open"><span data-testid="queries-view__status-open-label">Open</span></v-chip>
                  <v-chip v-else label color="lightgreen" class="teal--text" data-testid="queries-view__status-closed"><span data-testid="queries-view__status-closed-label">Closed</span></v-chip>
                </div>
              </div>
            </div>
            <div class="align-center d-flex" v-if="queryDetails._id && !loading" data-testid="queries-view__details-row">
              <div data-testid="queries-view__details-main">
                <div class="d-flex align-center" data-testid="queries-view__details-title-row">
                  <h3 class="font-size-md font-weight-medium mr-2" data-testid="queries-view__details-title">
                    {{ queryDetails.issue || {} }}
                  </h3>
                  <v-spacer></v-spacer>
                </div>
                <div data-testid="queries-view__details-date-row">
                  <span class="mr-2 mt-3 mb-3" data-testid="queries-view__details-date-label"><v-icon class="mr-1" data-testid="queries-view__details-date-icon">mdi-calendar-range</v-icon> Request date:
                  </span>
                  <span class="mr-1" data-testid="queries-view__details-date-value">
                    {{ $nova.formatDate(queryDetails.created_at) }}</span>
                </div>
              </div>
              <v-spacer></v-spacer>
              <div class="d-flex align-center" v-if="$route.params.QueryHelpDeskId" data-testid="queries-view__assign-row">
                <v-fade-transition leave-absolute>
                  <v-progress-circular v-if="assUserloading" size="18" color="Primary" indeterminate :width="1"
                    class="mr-2" data-testid="queries-view__assign-spinner"></v-progress-circular>
                </v-fade-transition>
                <lb-dropdown :disabled="queryDetails.stage == 2 ? '' : disabled" label="Assign User" v-model="assignUser"
                  :items="userList" itemtext="name" width="250px" itemvalue="_id" hidedetails @change="addAssignUser()" data-testid="queries-view__assign-dropdown" />
                <v-chip class="ml-2 Tabblue--text" color="lightblue" v-if="$nova.hasRight(right, 'support')" data-testid="queries-view__assign-sendtoclose">
                  <span data-testid="queries-view__assign-sendtoclose-label">Send To Close</span>
                </v-chip>
                <v-chip class="ml-2 teal--text" color="lightgreen"
                  v-if="queryDetails.stage === 0 && $nova.hasRight(right, 'support')" @click="closeQuery()" data-testid="queries-view__assign-close">
                  <span data-testid="queries-view__assign-close-label">Close</span>
                </v-chip>
                <v-chip class="ml-2 orange--text" color="lightorange" v-else @click="openQuery()" data-testid="queries-view__assign-reopen">
                  <span data-testid="queries-view__assign-reopen-label">Re Open</span></v-chip>
              </div>
            </div>
            <div v-if="queryDetails._id" class="overflow-scroll" style="max-height: 78vh; overflow:scroll" data-testid="queries-view__conversation-container">
              <div v-for="(item, index) in conversationList" :key="index" data-testid="queries-view__conversation-item">
                <div color="rgba(0,0,0,0)" flat class="mb-3 d-flex justify-end"
                  v-if="item.user_id_detail._id == $store.state.user.id" data-testid="queries-view__conversation-item-row">
                  <div class="text-right line-1" data-testid="queries-view__conversation-message-row">
                    <v-card elevation="8" dark class="ml-2 d-inline-block rounded-lg rounded-br-0 outlined"
                      max-width="500px" color="blue" data-testid="queries-view__conversation-message-card">
                      <v-card-text class="py-1 px-3" data-testid="queries-view__conversation-message-text">
                        <div class="white--text" data-testid="queries-view__conversation-message">{{ item.value }}</div>
                      </v-card-text>
                    </v-card>

                    <div class="timeFont mt-1" data-testid="queries-view__conversation-date">
                      {{ $nova.formatDate(item.created_at, "DD MMM yyyy h:mm A") }}
                    </div>
                  </div>
                  <v-tooltip bottom data-testid="queries-view__conversation-tooltip">
                    <template v-slot:activator="{ on, attrs }">
                      <v-avatar class="ml-2 mb-4" size="30" elevation="10" v-bind="attrs" v-on="on" :color="
                        item.user_id_detail._id == $store.state.user.id
                          ? 'indigo'
                          : 'red'
                      " data-testid="queries-view__conversation-avatar">
                        <span class="white--text" data-testid="queries-view__conversation-avatar-initial">{{
                          item.user_id_detail.name[0]
                        }}</span>
                      </v-avatar>
                    </template>
                    <span data-testid="queries-view__conversation-avatar-name">{{ item.user_id_detail.name }}</span>
                  </v-tooltip>
                </div>

                <div color="rgba(0,0,0,0)" flat class="d-flex mb-3" v-else data-testid="queries-view__conversation-item-row-other">
                  <v-tooltip bottom data-testid="queries-view__conversation-tooltip-other">
                    <template v-slot:activator="{ on, attrs }">
                      <v-avatar dark class="" size="30" elevation="10" v-bind="attrs" v-on="on" :color="
                        item.user_id_detail._id == $store.state.user.id
                          ? 'indigo'
                          : 'red'
                      " data-testid="queries-view__conversation-avatar-other">
                        <span class="white--text" data-testid="queries-view__conversation-avatar-initial-other">{{
                          item.user_id_detail.name[0]
                        }}</span>
                      </v-avatar>
                    </template>
                    <span data-testid="queries-view__conversation-avatar-name-other">{{ item.user_id_detail.name }}</span>
                  </v-tooltip>

                  <div data-testid="queries-view__conversation-message-row-other">
                    <v-card elevation="8" class="ml-2 d-inline-block  rounded-lg rounded-bl-0 outlined" max-width="500px"
                      color="blue-grey lighten-5" data-testid="queries-view__conversation-message-card-other">
                      <v-card-text class="py-1 px-3" data-testid="queries-view__conversation-message-text-other">
                        <div class="" data-testid="queries-view__conversation-message-other">{{ item.value }}</div>
                      </v-card-text>
                    </v-card>
                    <div class="ml-4 timeFont line-1" data-testid="queries-view__conversation-date-other">
                      {{ $nova.formatDate(item.created_at, "DD MMM yyyy h:mm A") }}
                    </div>
                  </div>
                </div>
              </div>

              <div v-if="queryDetails.stage !== 2 && ($nova.hasRight(right, 'edit')|| $nova.hasRight(right, 'add'))" data-testid="queries-view__input-row">
                <div class="d-flex align-center mt-10" data-testid="queries-view__input-row-inner">
                  <lb-string label="Query" v-model="queryMsg" hidedetails data-testid="queries-view__input" />
                  <v-btn @click="sendQuery" color="primary" class="ml-3" :loading="loading" data-testid="queries-view__send-btn">
                    <v-icon class="mr-2" data-testid="queries-view__send-icon">mdi-send</v-icon><span data-testid="queries-view__send-label">Send</span></v-btn>
                </div>
              </div>
            </div>
            <div v-if="loading && !queryDetails._id" data-testid="queries-view__loading">
              <v-skeleton-loader type="table-heading, list-item-two-line, article, article" data-testid="queries-view__loading-skeleton"></v-skeleton-loader>
            </div>
            <div v-else-if="!queryDetails._id" class="pa-8 title text-center grey--text" data-testid="queries-view__empty-state">
              No Data found
            </div>
          </div>
        </v-card-text>
      </v-card>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      right: "helpdesk",
      loading: false,
      assUserloading: false,
      querySendloading: false,
      queryMsg: null,
      chatList: [],
      queryDetails: {},
      queryObj: {},
      conversationList: {},
      queriesID: null,
      userList: null,
      assignUser: "",
    };
  },
  created() {
    this.refreshData();
  },
  activated() {
    this.refreshData();
  },
  methods: {
    refreshData() {
      this.loading = true;
      this.$route.params.QueryId
        ? (this.queriesID = this.$route.params.QueryId)
        : (this.queriesID = this.$route.params.QueryHelpDeskId);
      this.assignUser = "";
      this.axios.post("/v2/helpdesk/queries/getallusers").then((dt) => {
        if (dt.data.status === "success") {
          this.userList = dt.data.data;
          return this.axios.post("/v2/helpdesk/queries/get/" + this.queriesID);
        }else throw Error("Error getting user list");
      }).then(dt => {
        if (dt.data.status === "success") {
          this.queryDetails = dt.data.data[0] || {};
          if (this.queryDetails.assign_to) {
            this.assignUser = this.queryDetails.assign_to;
          }
          return this.axios.post("/v2/helpdesk/queries/conversation/get/" + this.queriesID);
        }else throw Error("Error getting query detail");
      }).then(dt => {
        if (dt.data.status === "success") {
          this.conversationList = dt.data.data;
        }else throw Error("Error getting conversations");
      }).catch((err) => {
        this.$store.commit("sbError", err.message || err || "Unknown error!");
        console.log(err);
      })
      .finally(() => {
        this.loading = false;
      });
    },

    sendQuery() {
      this.querySendloading = true;
      this.queryObj = {
        queries_id: this.queriesID,
        value: this.queryMsg,
      };
      this.axios
        .post("/v2/helpdesk/queries/conversation/add", { data: this.queryObj })
        .then((dt) => {
          if (dt.data.status === "success") {
            this.queryMsg = null;
            this.refreshData();
            this.$store.commit("sbSuccess", "query send successfully");
          }
          else {
            this.queryMsg = null;
            this.$store.commit("sbError", "Query cannot be empty");
          }
        })
        .catch((err) => {
          this.$store.commit("sbError", err.message || err || "Unknown error!");
          console.log(err);
        })
        .finally(() => {
          this.querySendloading = false;
        });
    },
    closeQuery() {
      this.loading = true;
      this.axios
        .post("/v2/helpdesk/queries/close/" + this.queriesID)
        .then((dt) => {
          if (dt.data.status === "success") {
            this.refreshData();
            this.$store.commit("sbSuccess", "Query closed successfully");
          }
        })
        .catch((err) => {
          this.$store.commit("sbError", err.message || err || "Unknown error!");
          console.log(err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    openQuery() {
      this.loading = true;
      this.axios
        .post("/v2/helpdesk/queries/open/" + this.queriesID)
        .then((dt) => {
          if (dt.data.status === "success") {
            this.refreshData();
            this.$store.commit("sbSuccess", "Query closed successfully");
          }
        })
        .catch((err) => {
          this.$store.commit("sbError", err.message || err || "Unknown error!");
          console.log(err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    addAssignUser() {
      this.assUserloading = true;
      let UserObject = { assign_to: this.assignUser };
      this.axios
        .post("/v2/helpdesk/queries/assignuser/" + this.queriesID, {
          data: UserObject,
        })
        .then((dt) => {
          if (dt.data.status === "success") {
            this.$store.commit("sbSuccess", "User Assigned successfully");
          }
        })
        .catch((err) => {
          this.$store.commit("sbError", err.message || err || "Unknown error!");
          console.log(err);
        })
        .finally(() => {
          this.assUserloading = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.timeFont {
  font-size: 9px !important;
}
</style>